import { villageInfo } from "@js/api/village";
import { mobile } from "@js/utils";

export default {
  namespaced: true,
  state: {
    info: {
      medal: 0,
      play_point: 0,
      total_play_point: 0,
      next_play_level_left: 0,
      play_level: 0,
      play_level_reward_rate: 0,
      season_end: Date.now(),
    },
  },
  mutations: {
    upDateInfo(state, info) {
      Object.assign(state.info, info);
    },
  },
  actions: {
    async upDateVillageInfo({ commit }) {
      let data = await villageInfo();
      if (data.status == 200) {
        // if (mobile().ios) {
        //   data.data.season_end = data.data.season_end.replace(/-/g, "/");
        // }
        commit("upDateInfo", data.data);
      }
    },
  },
};
